// AI-assisted: Claude 2026-08-07, human-reviewed: ausstehend
// Rekord-Erkennung: schwerstes Gewicht + geschätztes 1RM (Epley) je Übung.
import type { WorkoutEntry } from "./types"

/** Epley-Schätzung: w·(1+reps/30); 1 Wdh. = Gewicht selbst; auf 0,5 kg gerundet. */
export function epley1RM(weightKg: number, reps: number): number {
  if (weightKg <= 0 || reps <= 0) return 0
  const raw = reps === 1 ? weightKg : weightKg * (1 + reps / 30)
  return Math.round(raw * 2) / 2
}

/** Schwerstes je geloggtes Satz-Gewicht dieser Übung (0 = nie geloggt). */
export function maxWeight(entries: WorkoutEntry[], exerciseId: string): number {
  let max = 0
  for (const e of entries) {
    if (e.exercise !== exerciseId) continue
    for (const s of e.sets ?? []) max = Math.max(max, s.weight_kg || 0)
  }
  return max
}

/** Bestes geschätztes 1RM über alle Sätze dieser Übung (0 = nie geloggt). */
export function best1RM(entries: WorkoutEntry[], exerciseId: string): number {
  let max = 0
  for (const e of entries) {
    if (e.exercise !== exerciseId) continue
    for (const s of e.sets ?? []) max = Math.max(max, epley1RM(s.weight_kg || 0, s.reps || 0))
  }
  return max
}

export interface RecordHit {
  kind: "weight" | "e1rm"
  value: number
}

/** Rekord nur, wenn die Übung vorher schon geloggt war (erstes Mal ≠ Rekord)
 *  und der neue Bestwert den alten schlägt — Gewicht vor 1RM. */
export function checkRecord(entriesBefore: WorkoutEntry[], newEntry: WorkoutEntry): RecordHit | null {
  if (!entriesBefore.some((e) => e.exercise === newEntry.exercise)) return null
  const one = [newEntry]
  const wNew = maxWeight(one, newEntry.exercise)
  if (wNew > maxWeight(entriesBefore, newEntry.exercise)) return { kind: "weight", value: wNew }
  const eNew = best1RM(one, newEntry.exercise)
  if (eNew > best1RM(entriesBefore, newEntry.exercise)) return { kind: "e1rm", value: eNew }
  return null
}
